import * as React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableFooter from '@mui/material/TableFooter'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import InsertCommentIcon from '@mui/icons-material/InsertComment'
import LastPageIcon from '@mui/icons-material/LastPage'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Stack } from '@mui/material'
import TableHead from '@mui/material/TableHead'
import '../../../App.css'
import '../../../css/modal.scss'
import { updateDestBrnch, updateDestCity, getListData } from '../../../store/common/common_action'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { useEffect } from 'react'
import { activeClass, focusElemnt, formatDate2 } from '../../common/helper'
import moment from 'moment'
import { useAtom } from 'jotai'
import { companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { useTranslation } from '../../../i18n/I18nProvider'

const MiddleSection = ({
  getListData,
  data,
  details,
  inputCheck,
  selelectedData,
  setSelectedData,
  SetLrNos,
  cancelEdit,
  cancelEditData,
}) => {
  const { translations } = useTranslation()
  const bt = translations.branchTransfer || {}
  const cs = translations.common || {}
  const { common } = data
  const { strtCity, strtBrnch, loginData, listData } = { ...common }
  const [companySettings] = useAtom(companySettingsAtom)
  const { UseToPayAsCOD = 0 } = companySettings
  const { DefaultCurrencyID } = companySettings
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(8)

  // All State
  const [state, setState] = useState({
    // ListData:[],
    startIndex: 0,
    lastIndex: 8,
    Total: 0,
    TotalAmount: 0,
  })
  const { startIndex, lastIndex, Total, TotalAmount } = state
  const [ListData, setListData] = useState()
  const [TableListData, setTableListData] = useState('')
  const [filtered, setFiltered] = useState([])
  const [searchStatus, setSearchStatus] = useState(false)
  const selectAllRef = React.useRef(null)
  // All useEffects
  // useEffect(() => {
  //   if (listData?.Table?.length >= 1) {
  //     const arry = listData?.Table?.map((val) => ({ ...val, checked: false }))
  //     setTableListData('DataLoaded')
  //     setListData(arry)
  //     setTimeout(() => {
  //       document.getElementById('checkbox_0').focus()
  //     }, 0)

  //   } else {
  //     setListData([])
  //     setTableListData('Empty')
  //   }
  // }, [listData])
  useEffect(() => {
    if (listData?.Table?.length >= 1) {
      const arry = listData?.Table?.map((val, index) => ({
        ...val,
        checked: false,
        PaymentTypeDet:
          UseToPayAsCOD === 1
            ? val.PaymentType === 2
              ? 'COD'
              : val.PaymentType === 7
                ? 'COD(MANUAL)'
                : val.PaymentType === 9
                  ? 'COD(DDDV)'
                  : val.PaymentTypeDet
            : val.PaymentTypeDet,
      }));
      setTableListData('DataLoaded');
      setListData(arry);

      setTimeout(() => {
        document.getElementById('checkbox_0')?.focus();
      }, 0);
    } else {
      setListData([]);
      setTableListData('Empty');
    }
  }, [listData, UseToPayAsCOD]);

  useEffect(() => {
    if (inputCheck == true) {
      if (selelectedData?.length === 0 || selelectedData === undefined) {
        const arry = listData?.Table?.map((val) => ({ ...val, checked: true }))
        setListData(arry)
        setSelectedData(listData?.Table)
      } else {
        const selBookId = selelectedData.map(({ BookingID }) => BookingID)
        let filterLR = listData?.Table.filter((item) => selBookId.includes(item.BookingID))
        setSelectedData(filterLR)
      }
    }
  }, [listData, inputCheck])
  useEffect(() => {
    const citrus = listData?.Table?.slice(startIndex, lastIndex)
    const total = citrus?.map((item) => item?.Quantity).reduce((partialSum, a) => partialSum + a, 0)
    const totalAmt = citrus?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
    setState({ ...state, Total: total, TotalAmount: totalAmt?.toFixed(2) })
  }, [startIndex, lastIndex, listData])

  // All useEffects end
  //All on  Changed


  const onChange = (e, i, BookingIDItem) => {
    const { checked, value, id } = e.target
    if (checked) {
      // (searchStatus ? filtered : ListData)?.map((val) => (val.BookingID === Number(id) ? (val.checked = true) : ''))
      ListData?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = true) : ''))
      filtered?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = true) : ''))
      const data = (searchStatus ? filtered : ListData)?.filter((val) => val.BookingID == Number(BookingIDItem))
      const selectedObject = [...selelectedData, data[0]]
      setSelectedData(selectedObject)
    } else {
      // (searchStatus ? filtered : ListData)?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = false) : ''))
      ListData?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = false) : ''))
      filtered?.map((val) => (val.BookingID === Number(BookingIDItem) ? (val.checked = false) : ''))
      const data = selelectedData.filter((item) => item.BookingID !== Number(BookingIDItem))
      setSelectedData(data)
    }
    setTimeout(() => {
      focusElemnt(`checkbox_${i}`);
    }, 3)

  }
  function dateFormat(inputDate, format) {
    //parse the input date
    const date = new Date(inputDate)

    //extract the parts of the date
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()

    //replace the month
    format = format.replace('MM', month.toString().padStart(2, '0'))

    //replace the year
    if (format.indexOf('yyyy') > -1) {
      format = format.replace('yyyy', year.toString())
    } else if (format.indexOf('yy') > -1) {
      format = format.replace('yy', year.toString().substr(2, 2))
    }

    //replace the day
    format = format.replace('dd', day.toString().padStart(2, '0'))

    return format
  }
  const addRemoveKeydown = (e, i) => {
    if (e.key === 'ArrowDown') {
      focusElemnt(`checkbox_${i + 1}`);
    }
    if (e.key === 'ArrowUp') {
      focusElemnt(`checkbox_${i - 1}`);
    }
    if (e.key === 'Enter') {
      focusElemnt('TrToBranch');
    }
    if (e.key === 'Escape') {
      focusElemnt("show-btn");
    }
  }



  const InsideRowContent = ({ item, index }) => {
    const [show, setShow] = useState(false)
    //this function for  total
    const handleCalculation = (list, name) => {
      let total = 0
      for (let i in list) {
        total = total + Number(list[i][name])
      }
      return total.toLocaleString('en-IN')
    }

    const handleTotalCalculation = (list) => {
      let frieght = list.ConsignmentData.map((item) => item?.Freight).reduce((partialSum, a) => partialSum + a, 0)
      let total = frieght + list.AllCartage + list.AllHamali + list.Other + list.Valuation + list.GST
      return total.toLocaleString('en-IN')
    }

    return (
      <>
        <TableRow key={index}>
          <TableCell className="checkbox-ctrl">
            <input type="checkbox" id={`checkbox_${index}`} onChange={(e) => onChange(e, index, item.BookingID)} checked={item.checked} onKeyDown={(e) => addRemoveKeydown(e, index)} />
          </TableCell>
          <TableCell style={{ whiteSpace: 'nowrap' }}>
            {item.LRNO}
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.ManualLRNo}>
              {item.ManualLRNo}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.BookingDateTime}>
              {moment(item.BookingDateTime).format('DD MMM YYYY  LT')}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.DescriptionDet}>
              {/* hii */}
              {item?.ConsignmentData?.length === 1 ? item.DescriptionDet : 'Multi'}
            </span>
          </TableCell>
          <TableCell>
            <span className={activeClass(item.PaymentTypeDet)} title={item.PaymentTypeDet}>
              {item.PaymentTypeDet}
            </span>
          </TableCell>
          <TableCell style={{ textAlign: 'right' }}>
            <span style={{ fontSize: '13px', paddingRight: '30px' }} title={item.Quantity}>
              {item.Quantity}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.Sender}>
              {item.Sender}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.RecName}>
              {item.RecName}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.FromCity}>
              {item.FromCity}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '13px' }} title={item.ToCity}>
              {item.ToCity}
            </span>
          </TableCell>
          <TableCell style={{ textAlign: 'right' }}>
            <span style={{ fontSize: '13px', paddingRight: '50px' }} title={item.NetAmount}>
              {/* {item.NetAmount} */}
              {Number(item.NetAmount).toLocaleString('en-IN')}
            </span>
          </TableCell>
          <TableCell className="iconCell" style={{ textAlign: 'right', display: 'flex', justifyContent: 'right', alignItems: 'end' }}>
            {item.Comments === '' ? (
              ''
            ) : (
              <span title={item.Comments}>
                <InsertCommentIcon id="iconBox" className="icon2" style={{ marginRight: '13px' }} />
              </span>
            )}
            <span
              onClick={() => {
                setShow(!show)
              }}
            >
              {show ? <RemoveCircleIcon id="iconBox" className="icon2" /> : <AddCircleIcon id="iconBox" className="icon2" />}
            </span>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={14} style={{ padding: '0' }}>
            <div
              className="tabelAccordionWrapper"
              style={{
                maxHeight: '110px',
                overflowY: 'scroll',
              }}
            >
              <Table className="table1 table-branch sub-table" size="small" aria-label="a dense table">
                <TableBody className="filter-data-row">
                  {show && (
                    <>
                      <TableRow key={index} style={{ background: '#E5D6CF' }}>
                        <TableCell className="checkbox-ctrl" style={{ background: '#E5D6CF' }}></TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold' }} title={'ConsignmentSubType'}>
                            {bt.consignType}
                          </span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{cs.description}</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{bt.unit}</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{bt.goodsValue}</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{bt.weight}</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{bt.rate}</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{bt.frieght}</span>
                        </TableCell>

                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{bt.cartage}</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{bt.hamali}</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{bt.other}</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{DefaultCurrencyID === 2 ? bt.insurance : bt.valuation}</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{cs.GST}</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>{cs.total}</span>
                        </TableCell>
                      </TableRow>

                      {item.ConsignmentData.map((val, i) => {
                        return (
                          <>
                            <TableRow key={i} style={{ background: '#FBEDE7' }}>
                              <TableCell className="checkbox-ctrl" style={{ background: '#FBEDE7' }}></TableCell>
                              <TableCell>
                                <span style={{ fontSize: '10px' }} title={val.ConsignmentSubType}>
                                  {val.ConsignmentSubType}
                                </span>
                              </TableCell>
                              <TableCell>
                                <span style={{ fontSize: '10px' }} title={val.Description}>
                                  {val.Description}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Quantity}>
                                  {val.Quantity}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.GoodsValue}>
                                  {val.GoodsValue}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.ActualWeight}>
                                  {val.ActualWeight}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Rate}>
                                  {val.Rate}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Freight}>
                                  {/* {val.Freight} */}
                                  {Number(val.Freight).toLocaleString('en-IN')}
                                </span>
                              </TableCell>

                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.AllCartage}>
                                  {/* {item.AllCartage} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.AllCartage}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.AllHamali}>
                                  {/* {item.AllHamali} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.AllHamali}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.Other}>
                                  {item.ConsignmentData.length > 1 ? 0 : item.Other}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.Valuation}>
                                  {/* {item.Valuation} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.Valuation}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={Number(item.GST).toLocaleString('en-IN')}>
                                  {item.ConsignmentData.length > 1 ? 0 : Number(item.GST).toLocaleString('en-IN')}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.Valuation}>
                                  {item.ConsignmentData.length > 1 ? 0 : handleTotalCalculation(item)}
                                </span>
                              </TableCell>
                            </TableRow>
                          </>
                        )
                      })}
                      {item.ConsignmentData.length > 1 ? (
                        <TableRow style={{ background: '#e9d5cf' }}>
                          <TableCell className="checkbox-ctrl" style={{ background: '#e9d5cf' }}></TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{bt.grandTotal}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}></span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'Quantity')}
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'GoodsValue')}
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'ActualWeight')}
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>{handleCalculation(item.ConsignmentData, 'Rate')}</span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'Freight')}
                            </span>
                          </TableCell>

                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.AllCartage}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.AllHamali}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.Other}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.Valuation}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>
                              {Number(item.GST).toLocaleString('en-IN')}
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>{handleTotalCalculation(item)}</span>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ''
                      )}
                    </>
                  )}
                </TableBody>
              </Table>
            </div>
          </TableCell>
        </TableRow>
      </>
    )
  }

  //All Functionality of pagination  start
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  function TablePaginationActions(props) {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
      setState({ ...state, startIndex: 0, lastIndex: 8 })
    }

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
      setState({ ...state, startIndex: startIndex - 8, lastIndex: startIndex })
    }

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
      if (listData?.Table?.length >= lastIndex + 8) {
        setState({ ...state, startIndex: lastIndex, lastIndex: lastIndex + 8 })
      } else {
        setState({ ...state, startIndex: lastIndex, lastIndex: listData?.Table?.length + 1 })
      }
    }

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
      const div = listData?.Table?.length % 8
      if (div == 0) {
        const index = listData?.Table?.length - 8
        setState({ ...state, startIndex: index, lastIndex: listData?.Table?.length + 1 })
      } else {
        const index = listData?.Table?.length - (listData?.Table?.length % 8)
        setState({ ...state, startIndex: index, lastIndex: listData?.Table?.length + 1 })
      }
    }

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
          style={{ padding: '0px', margin: '0px' }}
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          style={{ padding: '0px', margin: '0px' }}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  }
  //All Functionality of pagination end

  let repeatdata = [
    { id: 0, name: 'contains', colName: 'LRNO' },
    { id: 1, name: 'contains', colName: 'ManualLRNo' },
    { id: 2, name: 'contains', colName: 'BookingDateTime' },
    { id: 3, name: 'contains', colName: 'DescriptionDet' },
    { id: 4, name: 'contains', colName: 'PaymentTypeDet' },
    { id: 5, name: 'contains', colName: 'Quantity' },
    { id: 6, name: 'contains', colName: 'Sender' },
    { id: 7, name: 'contains', colName: 'RecName' },
    { id: 8, name: 'contains', colName: 'FromCity' },
    { id: 9, name: 'contains', colName: 'ToCity' },
    { id: 10, name: 'contains', colName: 'NetAmount' },
  ]
  const handleChangeContain = (id, name) => {
    var userInput = document.getElementsByName('searchInput')[id].value
    var count = 0
    const lData = []
    const data = ListData
    if (userInput !== '') {
      var regex = new RegExp(userInput.trim().replace(/\\/g, "\\\\"), 'i')
      {
        data.map((val) => {
          if ((val[name] != null ? val[name].toString() : '').search(regex) !== -1) {
            const x = {
              LRNO: val.LRNO,
              ManualLRNo: val.ManualLRNo,
              BookingDateTime: val.BookingDateTime,
              DescriptionDet: val.DescriptionDet,
              PaymentTypeDet: val.PaymentTypeDet,
              Quantity: val.Quantity,
              Sender: val.Sender,
              RecName: val.RecName,
              FromCity: val.FromCity,
              ToCity: val.ToCity,
              NetAmount: val.NetAmount,
              ConsignmentData: val.ConsignmentData,
              ActualWeight: val.ActualWeight,
              AllCartage: val.AllCartage,
              AllHamali: val.AllHamali,
              BKFreight: val.BKFreight,
              BookingDateTime: val.BookingDateTime,
              BookingID: val.BookingID,
              CartageAmount: val.CartageAmount,
              ChallanNo: val.ChallanNo,
              CollectionCharges: val.CollectionCharges,
              Comments: val.Comments,
              Description: val.Description,
              DestinationBranchID: val.DestinationBranchID,
              DestinationBranchName: val.DestinationBranchName,
              DocumentCharges: val.DocumentCharges,
              Freight: val.Freight,
              GST: val.GST,
              GoodsValue: val.GoodsValue,
              Insurance: val.Insurance,
              ModeOfPayment: val.ModeOfPayment,
              Other: val.Other,
              PARCEL: val.PARCEL,
              PaymentType: val.PaymentType,
              Rate: val.Rate,
              RecAddress: val.RecAddress,
              RecMobileNo: val.RecMobileNo,
              ReceiverEmailID: val.ReceiverEmailID,
              ReceiverGSTN: val.ReceiverGSTN,
              Select: val.Select,
              SenderAddress: val.SenderAddress,
              SenderEmailID: val.SenderEmailID,
              SenderGSTN: val.SenderGSTN,
              SenderMobileNo: val.SenderMobileNo,
              ServiceTaxAmount: val.ServiceTaxAmount,
              SubType: val.SubType,
              ToCity: val.ToCity,
              Valuation: val.Valuation,
              checked: val.checked,
            }
            lData.push(x)
            count++
          }
        })
      }
      setFiltered(lData)
      setSearchStatus(true)
    } else {
      setFiltered([])
      setSearchStatus(false)
    }
  }
  const visibleData = searchStatus ? filtered || [] : ListData || []
  const visibleBookingIds = visibleData.map((item) => item.BookingID)
  const availableRowsSelectedCount = visibleData.filter((item) => item.checked).length
  const showSelectAllCheckbox = visibleData.length > 1
  const areAllVisibleSelected = showSelectAllCheckbox && availableRowsSelectedCount === visibleData.length
  const areSomeVisibleSelected = availableRowsSelectedCount > 0 && !areAllVisibleSelected

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = areSomeVisibleSelected
    }
  }, [areSomeVisibleSelected])

  const handleToggleVisibleRows = (e) => {
    const shouldSelect = e.target.checked
    const visibleBookingIdSet = new Set(visibleBookingIds)

    setListData((prev) =>
      prev?.map((item) =>
        visibleBookingIdSet.has(item.BookingID) ? { ...item, checked: shouldSelect } : item
      ) || []
    )
    setFiltered((prev) =>
      prev?.map((item) =>
        visibleBookingIdSet.has(item.BookingID) ? { ...item, checked: shouldSelect } : item
      ) || []
    )

    if (shouldSelect) {
      const mergedSelection = [...(selelectedData || [])]
      visibleData.forEach((item) => {
        if (!mergedSelection.some((selectedItem) => selectedItem.BookingID === item.BookingID)) {
          mergedSelection.push({ ...item, checked: true })
        }
      })
      setSelectedData(mergedSelection)
      return
    }

    setSelectedData((selelectedData || []).filter((item) => !visibleBookingIdSet.has(item.BookingID)))
  }

  return (
    <Stack sx={{ maxHeight: 300, minHeight: 260, minWidth: 650, margin: 1, marginRight: 3, marginLeft: 3 }}>
      {cancelEdit == true ? (
        <TableContainer className="lr-popup-table lrModel" component={Paper}>
          <Table style={{}} className="table1 table-branch" size="small" aria-label={bt.denseTableAriaLabel} id="showlisttable">
            <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
              <TableRow style={{ background: '#d9edff' }}>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px 10px 25px', fontWeight: 'bold' }}>{bt.select}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.lrWayBillNo}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.vehicleNo}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.bookingDate}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.consignType}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{cs.paymentType}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px 10px 40px', fontWeight: 'bold', paddingLeft: '20px' }}>
                  {bt.units}
                </TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{cs.sender}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{cs.receiver}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.fromCity}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.toCity}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'right', paddingRight: '50px' }}>
                  {cs.amount}
                </TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'right', paddingRight: '30px' }}>
                  {cs.activity}
                </TableCell>
                {/* <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}></TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody className="filter-data-row">
              <TableRow>
                <TableCell className="checkbox-ctrl">
                  {inputCheck ? (
                    <input type="checkbox" id={`checkbox_${cancelEditData.BookingID}`} name="record" checked={true} disabled={true} />
                  ) : (
                    <input type="checkbox" id={cancelEditData.BookingID} disabled={true} />
                  )}
                </TableCell>
                <TableCell>
                  <span style={{ fontSize: '10px' }} title={cancelEditData.LRNO}>
                    {cancelEditData.LRNO}
                  </span>
                </TableCell>
                <TableCell>
                  <span style={{ fontSize: '10px' }} title={cancelEditData.ManualLRNo}>
                    {cancelEditData.VehicleNo}
                  </span>
                </TableCell>
                <TableCell>
                  <span style={{ fontSize: '10px' }} title={cancelEditData.BookingDateTime}>
                    {dateFormat(cancelEditData.BookingDateTime.split(' ')[0], 'dd-MM-yyyy')}
                  </span>
                </TableCell>
                <TableCell>
                  <span style={{ fontSize: '10px' }} title={cancelEditData.DescriptionDet}>
                    {/* hii */}
                    {cancelEditData.DescriptionDet}
                  </span>
                </TableCell>
                <TableCell>
                  <span style={{ fontSize: '10px' }} title={cancelEditData.PaymentTypeDet}>
                    {cancelEditData.PaymentTypeDet}
                  </span>
                </TableCell>
                <TableCell style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: '10px', paddingRight: '30px' }} title={cancelEditData.Quantity}>
                    {cancelEditData.Quantity}
                  </span>
                </TableCell>
                <TableCell>
                  <span style={{ fontSize: '10px' }} title={cancelEditData.Sender}>
                    {cancelEditData.Sender}
                  </span>
                </TableCell>
                <TableCell>
                  <span style={{ fontSize: '10px' }} title={cancelEditData.RecName}>
                    {cancelEditData.RecName}
                  </span>
                </TableCell>
                <TableCell>
                  <span style={{ fontSize: '10px' }} title={cancelEditData.FromCity}>
                    {cancelEditData.FromCity}
                  </span>
                </TableCell>
                <TableCell>
                  <span style={{ fontSize: '10px' }} title={cancelEditData.ToCity}>
                    {cancelEditData.ToCity}
                  </span>
                </TableCell>
                <TableCell style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: '10px', paddingRight: '50px' }} title={cancelEditData.NetAmount}>
                    {/* {cancelEditData.NetAmount} */}
                    {Number(cancelEditData.NetAmount).toLocaleString('en-IN')}
                  </span>
                </TableCell>
                <TableCell
                  className="iconCell"
                  style={{ textAlign: 'right', display: 'flex', justifyContent: 'right', aligncancelEditDatas: 'end' }}
                >
                  {cancelEditData.Comments === '' ? (
                    ''
                  ) : (
                    <span title={cancelEditData.Comments}>
                      <InsertCommentIcon id="iconBox" className="icon2" style={{ marginRight: '10px' }} />
                    </span>
                  )}
                </TableCell>
              </TableRow>
              {/* ))} */}
            </TableBody>
            {/* ):""}
             */}
          </Table>
        </TableContainer>
      ) : (
        <TableContainer className="lr-popup-table lrModel" component={Paper}>
          <Table style={{}} className="table1 tableV2-branch" size="small" aria-label={bt.denseTableAriaLabel} id="showlisttable">
            <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
              <TableRow style={{ background: '#DAEDFE' }}>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px 10px 25px', fontWeight: 'bold' }}>{bt.select}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.lrWayBillNo}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.manualLr}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.bookingDate}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.consignType}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{cs.paymentType}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px 10px 40px', fontWeight: 'bold', paddingLeft: '20px' }}>
                  {bt.units}
                </TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{cs.sender}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{cs.receiver}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.fromCity}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>{bt.toCity}</TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'right', paddingRight: '50px' }}>
                  {cs.amount}
                </TableCell>
                <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign: 'right', paddingRight: '30px' }}>
                  {cs.activity}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="checkbox-ctrl">
                  {showSelectAllCheckbox ? (
                    <div className="filter-input" style={{ justifyContent: 'center' }}>
                      <input
                        ref={selectAllRef}
                        type="checkbox"
                        checked={areAllVisibleSelected}
                        disabled={inputCheck}
                        onChange={handleToggleVisibleRows}
                      />
                    </div>
                  ) : null}
                </TableCell>
                {repeatdata.map((item, i) => (
                  <>
                    <TableCell key={i}>
                      <div className={`filter-input ${i == 11 ? 'last-filter' : null}`}>
                        <input
                          className="field"
                          name="searchInput"
                          placeholder={item.name}
                          onChange={() => {
                            handleChangeContain(item.id, item.colName)
                          }}
                          style={{ width: '75px' }}
                        />
                        <FilterAltIcon />
                      </div>
                    </TableCell>
                  </>
                ))}
              </TableRow>
            </TableHead>
            {TableListData === 'Empty' ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '14px',
                        }}
                      >
                        <span>{cs.noResultsFound}</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : TableListData === 'DataLoaded' ? (
              <TableBody className="filter-data-row">
                {(rowsPerPage > 0
                  ? (searchStatus ? filtered : ListData)?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : searchStatus
                    ? filtered
                    : ListData
                )?.map((item, index) => (
                  <InsideRowContent item={item} index={index} key={index} />
                ))}
              </TableBody>
            ) : (
              ''
            )}
            <TableFooter>
              <TableRow>
                <TableCell colSpan={5} style={{ fontSize: '13px', fontWeight: 'bold' }}></TableCell>
                <TableCell style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right', paddingRight: '7px' }}>{cs.total}</TableCell>
                <TableCell style={{ fontSize: '9px', fontWeight: 'bold', textAlign: 'right', paddingRight: '63px' }}>
                  {Total === undefined ? '' : Number(Total).toLocaleString('en-IN')}
                </TableCell>
                <TableCell colSpan={3} style={{ fontSize: '13px', fontWeight: 'bold' }}></TableCell>
                <TableCell colSpan={2} style={{ fontSize: '9px', fontWeight: 'bold', textAlign: 'right', paddingRight: '50px' }}>
                  {TotalAmount === undefined ? '' : Number(TotalAmount).toLocaleString('en-IN')}
                </TableCell>
                <TableCell colSpan={2}></TableCell>
              </TableRow>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                  // colSpan={3}
                  count={listData?.Table?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  className="test123"
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page',
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                // className="table-pagination-bottom"
                />
              </TableRow>
            </TableFooter>
            {/* <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
            // colSpan={3}
            count={listData?.Table?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            SelectProps={{
              inputProps: {
                'aria-label': 'rows per page',
              },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
            className="table-pagination-bottom"
          /> */}
          </Table>
        </TableContainer>
      )}
    </Stack>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  getListData,
  updateDestCity,
  updateDestBrnch,
}
export default connect(mapStateToProps, mapDispatchToProps)(MiddleSection)
